var _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceHolderFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5554 48.1111H49.1109V52.5556H46.8887V48.1111H42.4443V45.8889H46.8887V41.4444H49.1109V45.8889H53.5554M55.7776 37H40.2221C38.9887 37 37.9998 37.9889 37.9998 39.2222V54.7778C37.9998 55.3671 38.234 55.9324 38.6507 56.3491C39.0675 56.7659 39.6327 57 40.2221 57H55.7776C56.367 57 56.9322 56.7659 57.349 56.3491C57.7657 55.9324 57.9998 55.3671 57.9998 54.7778V39.2222C57.9998 38.6329 57.7657 38.0676 57.349 37.6509C56.9322 37.2341 56.367 37 55.7776 37Z",
    fill: "#1F1F1F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 10,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5714 16H43.4286C44.641 16 45.8038 16.4816 46.6611 17.3388C47.5184 18.1961 48 19.3588 48 20.5711V43.4266C48 44.6389 47.5184 45.8016 46.6611 46.6588C45.8038 47.5161 44.641 47.9977 43.4286 47.9977H20.5714C19.359 47.9977 18.1962 47.5161 17.3389 46.6588C16.4816 45.8016 16 44.6389 16 43.4266V20.5711C16 19.3588 16.4816 18.1961 17.3389 17.3388C18.1962 16.4816 19.359 16 20.5714 16Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38.8579L41.1429 32.0013L34.2857 38.8236M43.4286 48.0001L22.8571 27.4302L16 34.2868",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7843 24.0011C41.7843 24.9872 40.9849 25.7867 39.9986 25.7867C39.0123 25.7867 38.2129 24.9872 38.2129 24.0011C38.2129 23.015 39.0123 22.2156 39.9986 22.2156C40.9849 22.2156 41.7843 23.015 41.7843 24.0011Z",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4443 49.8889H50.8888V53.4444H49.111V49.8889H45.5554V48.1111H49.111V44.5556H50.8888V48.1111H54.4443M56.2221 41H43.7776C42.791 41 41.9999 41.7911 41.9999 42.7778V55.2222C41.9999 55.6937 42.1872 56.1459 42.5206 56.4793C42.854 56.8127 43.3061 57 43.7776 57H56.2221C56.6936 57 57.1458 56.8127 57.4792 56.4793C57.8126 56.1459 57.9999 55.6937 57.9999 55.2222V42.7778C57.9999 42.3063 57.8126 41.8541 57.4792 41.5207C57.1458 41.1873 56.6936 41 56.2221 41Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceHolderFile);
export default __webpack_public_path__ + "static/media/PlaceHolderFile.4a435654e3cf6111b8053ca75a4778cc.svg";
export { ForwardRef as ReactComponent };